import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store';
import { Mutations, Actions } from '@/store/enums/StoreEnums';
import { logEvent } from 'firebase/analytics';
import { breadcrumbMapper } from '@/core/data/menu-mapper';
import { CardData } from '@/core/static/cards-data';
// #region HR & GS
import HrgsLeaveRoutes from './hrgs/leave/HrgsLeaveRoutes';
import HrgsTravelokaTransactionRoutes from './hrgs/traveloka-transaction/HrgsTravelokaTransactionRoutes';
import HrgsAssessmentRoutes from './hrgs/assessment/HrgsAssessmentRoutes';
import { HrgsFormBuilderRoutes, HrgsMasterAssessmentRoutes, HrgsUnitCompetencyRoutes } from './hrgs/master-assessment/HrgsMasterAssessmentRoutes';
import HrgsDashboardReportRoutes from './hrgs/dashboard-report/HrgsDashboardReportRoutes';
// #endregion
// #region PSCM
import RequisitionRoutes from './pscm-service/requisition/RequisitionRoutes';
import MigoOnlineRoutes from './pscm-service/migo/MigoOnlineRoutes';
import MigoMasterRoutes from './pscm-service/migo/MigoMasterRoutes';
import ReportingRoutes from './pscm-service/reporting/ReportingRoutes';
// #endregion
// #region FINANCE
import FinanceServiceRoutes from './finance/FinanceServiceRoutes';
// #endregion
const staticTitle = 'BSpace 2.0';
const routes = [
    // #region general
    {
        path: '/',
        redirect: '/dashboard',
        component: () => {
            return import('@/layout/NoSideLayout.vue');
        },
        children: [
            {
                path: '/dashboard',
                name: 'mydashboard',
                meta: {
                    title: `${staticTitle} - Dashboard`
                },
                component: () => {
                    return import('@/views/crafted/general/Dashboard.vue');
                }
            },
            {
                path: '/settings',
                name: 'settingspage',
                meta: {
                    title: `${staticTitle} - Settings`
                },
                component: () => {
                    return import('@/views/crafted/general/settings.vue');
                }
            },
            {
                path: '/notifications',
                name: 'notificationspage',
                meta: {
                    title: `${staticTitle} - Notifications`
                },
                component: () => {
                    return import('@/views/crafted/general/Notifications.vue');
                }
            },
            {
                path: '/redirecting',
                name: 'redirecting',
                meta: {
                    title: `${staticTitle} - Redirecting`
                },
                component: () => {
                    return import('@/views/crafted/general/RedirectWarn.vue');
                }
            }
        ]
    },
    // #endregion general
    // #region sign in/sign up page
    {
        path: '/',
        component: () => {
            return import('@/components/page-layouts/Auth.vue');
        },
        children: [
            {
                path: '/',
                name: 'signin',
                meta: {
                    title: `${staticTitle} - Sign in`
                },
                component: () => {
                    return import('@/views/crafted/authentication/basic-flow/SignIn.vue');
                }
            }
        ]
    },
    // #endregion
    // #region modul page
    {
        path: '/',
        component: () => {
            return import('@/layout/NoSideLayout.vue');
        },
        children: [
            // #region HRGS
            {
                path: '/hrgs',
                name: 'hrgs',
                meta: {
                    title: `${staticTitle} - HR & GS`
                },
                component: () => {
                    return import('@/views/hrgs/Landing.vue');
                }
            },
            // #endregion
            // #region PSCM
            {
                path: '/pscmservice',
                name: 'pscmservice',
                meta: {
                    title: `${staticTitle} - PSCM Service`
                },
                component: () => {
                    return import('@/views/pscm/landing.vue');
                }
            },
            // #endregion
            // #region FINANCE
            {
                path: '/financeservice',
                name: 'financeservice',
                meta: {
                    title: `${staticTitle} - Finance`
                },
                component: () => {
                    return import('@/views/finance/landing.vue');
                }
            }
            // #endregion
        ]
    },
    {
        path: '/',
        component: () => {
            return import('@/layout/Layout.vue');
        },
        children: [
            // #region HRGS
            ...HrgsLeaveRoutes(staticTitle),
            ...HrgsTravelokaTransactionRoutes(staticTitle),
            ...HrgsAssessmentRoutes(staticTitle),
            ...HrgsMasterAssessmentRoutes(staticTitle),
            ...HrgsDashboardReportRoutes(staticTitle),
            ...HrgsFormBuilderRoutes(staticTitle),
            ...HrgsUnitCompetencyRoutes(staticTitle),
            // #endregion
            // #region PSCM
            ...RequisitionRoutes(staticTitle),
            ...MigoOnlineRoutes(staticTitle),
            ...MigoMasterRoutes(staticTitle),
            ...ReportingRoutes(staticTitle),
            // #endregion
            // #region FINANCE
            ...FinanceServiceRoutes(staticTitle)
            // #endregion
        ]
    },
    // #endregion
    // #region error page
    {
        path: '/',
        component: () => {
            return import('@/layout/NoSideLayout.vue');
        },
        children: [
            {
                path: '/error/:errorCode?',
                name: 'errorpage',
                meta: {
                    title: `${staticTitle} - Error`
                },
                component: () => {
                    return import('@/views/Error.vue');
                }
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/error/404'
    }
    // #endregion
];
export const router = createRouter({
    history: createWebHashHistory(),
    routes
});
const checkMenuLengthAndCheckRouteInGeneric = (to) => {
    const toRoute = to.fullPath
        .split('/')[to.fullPath.split('/').length - 1].split('?')[0];
    const genericPage = [
        'public',
        '404',
        'dashboard',
        'personal-info',
        '500',
        'sign-in',
        'sign-up',
        'password-reset',
        'login.microsoftonline.com',
        'settings'
    ];
    // handling redirect from micro
    if (store.getters.getAllMenu.length === 0 &&
        (to.name === 'redirecting' ||
            to.name === 'assessmentlist' ||
            to.name === 'hrgsdashboard' ||
            to.name === 'hrgs-assessment' ||
            to.name === 'hrgs-master-assessment' ||
            to.name === 'jci' ||
            to.name === 'contractreporting' ||
            to.name === 'purchaseinquiry' ||
            to.name === 'migoonline' ||
            to.name === 'migomaster' ||
            to.name === 'budget' ||
            to.name === 'report' ||
            to.name === 'master')) {
        if (to.name !== 'redirecting') {
            localStorage.setItem('shortURL', to.fullPath);
        }
        return (store.getters.getAllMenu.length === 0 && !genericPage.includes(toRoute));
    }
    else {
        return store.getters.getAllMenu.length > 0 && !genericPage.includes(toRoute);
    }
};
const checkAccess = (to, next) => {
    let found = false;
    if (checkMenuLengthAndCheckRouteInGeneric(to)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        CardData.forEach((val, index) => {
            if (to.fullPath.includes(val.link)) {
                found = true;
            }
        });
        if (to.name === 'redirecting') {
            found = true;
        }
        if (!found && to.name !== 'errorpage' && to.name !== 'notificationspage') {
            next({ name: 'errorpage' });
        }
    }
};
export default {
    install(app) {
        router.install(app);
        router.beforeEach((to, _from, next) => {
            // reset config to initial state
            store.commit(Mutations.RESET_LAYOUT_CONFIG);
            if (to) {
                store.dispatch(Actions.SET_BREADCRUMB_ACTION, breadcrumbMapper[to.name]);
            }
            checkAccess(to, next);
            // Scroll page to top on every route change
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 100);
            const title = to.meta.title
                ? to.meta.title
                : `${staticTitle} - Daftar Pekerjaan`;
            document.title = `${title}`;
            const analytics = app.config.globalProperties.$config;
            logEvent(analytics, 'page_view', {
                user: store.getters.currentUser.email,
                page: to.meta.title
            });
            next();
        });
        router.beforeResolve((to, _from, next) => {
            // check if new update available and current route is /hrgs
            if (window.location.pathname === '/hrgs' &&
                window.navigator.serviceWorker.controller) {
                window.navigator.serviceWorker.controller.postMessage({
                    type: 'CHECK_FOR_UPDATE'
                });
            }
            next();
        });
    }
};
